// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pcBT","col":"styles_col__g4J8w","actions":"styles_actions__2WJtl","conflict":"styles_conflict__4gWIk"};